import clsx from "clsx";

import { UI_TEXT_CLASS_NAME } from "../const";
import { UiTextTypographyProps } from "../type";

/**
 * Figma:https://www.figma.com/file/6bx1Rw0vJT7mLdFIl7jitZ/Admin_Component?type=design&node-id=348%3A338&mode=dev
 */
export const UiText = ({ children, size = "md", as = "p", bold = false, color }: UiTextTypographyProps) => {
  const uiTextClassName = clsx(UI_TEXT_CLASS_NAME({ size, bold }), color);

  switch (as) {
    case "p":
      return <p className={uiTextClassName}>{children}</p>;
    case "span":
      return <span className={uiTextClassName}> {children}</span>;
    case "div":
    default:
      return <div className={uiTextClassName}> {children}</div>;
  }
};
